import React from "react";
import { gtag } from "ga-gtag";
import { Dimensions, View, Text, useWindowDimensions } from "react-native";
// CustomDrawer.tsx

import { useRef, useState } from 'react';
import {
  Button,
  Animated,
  Pressable,
  StyleSheet,
} from 'react-native';
import { RDrawerProvider } from "./provider";

export interface RDrawerProps {
  drawerWidth: number;
  headerHeight: number;
  isVisible: boolean;
  onClose: () => void;
  children: React.ReactNode; // MainScreen content
  drawerContent: React.ReactNode;
}

export default function RDrawer({
  drawerWidth,
  headerHeight,
  isVisible,
  onClose,
  children,
  drawerContent,
}: RDrawerProps) {
  const screenWidth = Dimensions.get('window').width;
  const translateX = useRef(new Animated.Value(drawerWidth)).current;

  // Animate drawer open/close
  React.useEffect(() => {
    Animated.timing(translateX, {
      toValue: isVisible ? 0 : drawerWidth,
      duration: 300,
      useNativeDriver: true,
    }).start();
  }, [isVisible]);

  return (
    <View style={{ flex: 1, overflow: 'hidden', }}>
      {children}

      {/* Overlay */}
      {isVisible && (
        <Pressable style={[styles.overlay, { top: headerHeight }]} onPress={onClose}>
          {/* Touchable area to close the drawer */}
        </Pressable>
      )}

      {/* Drawer container */}
      <Animated.View
        style={[
          styles.drawer,
          {
            zIndex: 999,
            width: drawerWidth,
            top: headerHeight,
            right: 0,
            transform: [{ translateX }],
          },
        ]}
      >
        {drawerContent}
      </Animated.View>
    </View>
  );
}

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0,0,0,0.3)', // You can set to "transparent" if needed
    zIndex: 999,
  },
  drawer: {
    position: 'absolute',
    height: '91%',
    backgroundColor: '#fff',
    zIndex: 1000,
    overflow: 'hidden',
    shadowColor: '#000',
    shadowOffset: { width: -2, height: 2 }, // shadow moved down and left only
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 5,
  },
});

